module.exports = __webpack_public_path__ + "img/college-2-min.53e7a95a.png";